
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { workflowSchedulingReducer } from './reducer';
import { WorkflowSchedulingStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, workflowSchedulingReducer),
		EffectsModule.forFeature([WorkflowSchedulingStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class WorkflowSchedulingStoreModule { }
